// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"Drawer__materialize-textarea___3FSWK","modal-2463794813":"Drawer__modal-2463794813___2lMfo","container":"Drawer__container___1NNoz","dropdownIcon":"Drawer__dropdownIcon___10QzZ","drawerContainer":"Drawer__drawerContainer___37mXv","menuIcon":"Drawer__menuIcon___1hY1Y","userName":"Drawer__userName___2nJDB","buttonContainer":"Drawer__buttonContainer___2VUtS","loginButtonContainer":"Drawer__loginButtonContainer___1wOtT","joinUsButtonContainer":"Drawer__joinUsButtonContainer___1xzOc","closeButton":"Drawer__closeButton___132JP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuDrawer/Drawer.scss
// module id = 1498
// module chunks = 0